import withStyles from "@material-ui/core/styles/withStyles"
import React from "react"
import {
  fetchAlgReleases,
  fetchAlgs,
  fetchDevices,
  fetchUsers,
} from "../../actions/internalActions"
import { useLazyLoadSelector } from "../../util/redux"
import TabContentContainer from "../Common/ContentContainers/TabContentContainer"
import HomePageWrapper from "../Common/PageWrappers/HomePageWrapper"
import AlgMetadata from "../Internal/algMetadata"
import AlgReleases from "../Internal/algRelease"
import AllDevices from "../Internal/allDevices"
import UserAccounts from "../Internal/userAccounts"

const styles = (theme) => ({
  toolbar: theme.mixins.toolbar,
})

const Internal = () => {
  const LocationManager = React.lazy(() => import("../Internal/locationManager"))
  const tabs = [
    {
      label: "User Accounts",
      content: <UserAccounts />,
    },
    {
      label: "Devices",
      content: <AllDevices />,
    },
    {
      label: "Algs",
      content: <AlgMetadata />,
    },
    {
      label: "Alg Releases",
      content: <AlgReleases />,
    },
    {
      label: "Location Manager",
      content: (
        <div style={{ position: "relative", width: "100%", height: "80vh" }}>
          <React.Suspense fallback={<div>Loading…</div>}>
            <LocationManager />
          </React.Suspense>
        </div>
      ),
    },
  ]

  useLazyLoadSelector((state) => state.internal.users, fetchUsers, [], false)
  useLazyLoadSelector((state) => state.internal.devices, fetchDevices, [], false)
  useLazyLoadSelector((state) => state.internal.algs, fetchAlgs, [], false)
  useLazyLoadSelector((state) => state.internal.algReleases, fetchAlgReleases, [], false)

  return (
    <HomePageWrapper>
      <TabContentContainer tabs={tabs} />
    </HomePageWrapper>
  )
}

export default withStyles(styles)(Internal)
